const api = {
  development: 'http://localhost:8080',
  mock: '',
  production: 'http://xxxxxx',
}

export const baseURL = api[process.env.VUE_APP_ENV || 'development']
